import { useState, useEffect } from 'react';
import { getSiteDepartments } from 'services/analytics';
import { useDispatch } from 'react-redux';
import { showError } from '../../../../../redux/common/actions';
import { SHOW_ALL_OPTION } from '../../constants';

export const useDepartments = (siteAppID, showAll = true) => {
  const dispatch = useDispatch();
  const [departments, setDepartments] = useState([]);

  useEffect(() => {
    const loadDepartments = async () => {
      try {
        const response = await getSiteDepartments(siteAppID);
        if (response?.status) {
          const fetchedDepartments = response.data || [];
          // Only add 'Show All' if there are actual departments and showAll is true
          const updatedDepartments = (showAll && fetchedDepartments.length > 0)
            ? [SHOW_ALL_OPTION, ...fetchedDepartments]
            : fetchedDepartments;
          setDepartments(updatedDepartments);
        }
      } catch (error) {
        dispatch(showError('Failed to load departments'));
      }
    };
    loadDepartments();
  }, [siteAppID, showAll, dispatch]);

  return departments;
}; 